import { INTEGRATION_PROVIDERS } from '@vy/types';
import type { DeepPartial } from 'react-hook-form';
import type { MorningConfigurationFormValues } from '../MorningConfigurationFormSchema';
import { MorningIntegrationConfiguration } from '@vy/integrations-types';
import { SYNC_DIRECTIONS } from '../MorningConfigurationFormSchema';

export function getMorningIntegrationSettings(configuration: MorningConfigurationFormValues) {
  return {
    integrationProvider: INTEGRATION_PROVIDERS.morning,
    integrationConfiguration: mapFormValuesToMorningSettings(configuration),
  };
}

function mapFormValuesToMorningSettings(
  formValues: MorningConfigurationFormValues,
): DeepPartial<MorningIntegrationConfiguration> {
  const autoImportCustomers = formValues.syncCustomer === SYNC_DIRECTIONS.SYNC_TO_VAYU;

  return {
    generalConfig: {
      autoImportCustomers,
      autoExportInvoices: formValues.syncApprovedInvoices,
      invoiceNumberSyncStrategy: formValues.invoiceNumberSyncStrategy,
    },
    authConfig: {
      apiKey: formValues.apiKey,
      secretId: formValues.secretId,
    },
  };
}
